import React from 'react';
import { Link } from 'react-router-dom';

// Plain shell for the public-facing privacy / terms / data-deletion pages.
// No auth, no sidebar — just typography on a centred column so search
// engines (and Meta App Review) see clean static content.
const LegalLayout = ({ title, lastUpdated, children }) => (
  <div className="min-h-screen bg-white">
    <header className="border-b border-gray-200 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2 text-gray-900 font-semibold">
          <img src="/logo.png" alt="" className="w-7 h-7" onError={(e) => { e.target.style.display = 'none'; }} />
          <span>Gainrhino CRM</span>
        </Link>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-1 text-sm text-gray-600">
          <Link to="/integrations/claude" className="hover:text-gray-900">Claude</Link>
          <Link to="/privacy" className="hover:text-gray-900">Privacy</Link>
          <Link to="/terms" className="hover:text-gray-900">Terms</Link>
          <Link to="/data-deletion" className="hover:text-gray-900">Data Deletion</Link>
        </nav>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
      {lastUpdated && (
        <p className="text-xs text-gray-500 mb-8">Last updated: {lastUpdated}</p>
      )}
      <article className="prose prose-sm max-w-none text-gray-700 leading-relaxed space-y-4">
        {children}
      </article>
    </main>
    <footer className="border-t border-gray-200 mt-16">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 text-xs text-gray-500 flex flex-wrap items-center justify-between gap-2">
        <span>© {new Date().getFullYear()} Gainrhino. All rights reserved.</span>
        <span>info@gainrhino.com</span>
      </div>
    </footer>
  </div>
);

export default LegalLayout;
